import { Currency } from './currency';
import { AccreditationSpec } from './accreditation';

export class Port {
    id: number;
    name: String;
    value: number;
    currency: Currency;
    accreditationSpecsList: AccreditationSpec;
}